<template>
    <div class="component">
        <vue-headful
                :title="title + ' | W&S Docs'"
        />
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-dark">
                <li class="breadcrumb-item">
                    <router-link to="/methods">Methods</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="'/methods/' + theme_link">{{ theme_title }}</router-link>
                </li>
                <li class="breadcrumb-item active" v-for="(method, index) in methods" :key="index">
                    {{ method.method_title }}
                </li>
            </ol>
        </nav>

        <div class="mt-3 mb-3" v-for="(method, index) in methods" :key="index">
            <h2>{{ method.method_title }}</h2>
            <p v-html="method.method_content">{{ method.method_content }}</p>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "MethodView",
        props: ['method_id', 'theme_id'],
        data() {
            return {
                loading: true,
                result: false,
                methods: [],
                themes: [],
                title: null,
                theme_title: '',
                theme_link: ''
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/method.get?method_link=' + this.method_id + '&method_theme=' + this.theme_id)
                .then(response => {
                    this.methods = response.data.response;
                    this.title = response.data.response[0].method_title;
                });
            axios.get('https://api.write-and-share.ml/docs/theme.get?theme_link=' + this.theme_id)
                .then(response => {
                    this.themes = response.data.response;
                    this.theme_title = response.data.response[0].theme_title;
                    this.theme_link = response.data.response[0].theme_link;
                });
            this.loading = false;
        },
    }
</script>

<style scoped>

</style>
